"use client"

import { ShoppingBag } from "@medusajs/icons"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { useFrontendPreferences } from "@lib/frontend-preferences"

const EmptyCartMessage = () => {
  const { t } = useFrontendPreferences()

  return (
    <div
      className="sahil-acc-card mx-auto my-12 flex max-w-xl flex-col items-center gap-y-3 px-6 py-20 text-center"
      data-testid="empty-cart-message"
    >
      <div className="sahil-acc-stat__icon !mb-2 !h-16 !w-16 !rounded-full">
        <ShoppingBag />
      </div>
      <h1 className="sahil-acc-title">{t.cart.emptyTitle}</h1>
      <p className="sahil-acc-muted max-w-sm">{t.cart.emptyBody}</p>
      <LocalizedClientLink href="/store" className="sahil-acc-btn mt-4">
        {t.cart.exploreProducts}
      </LocalizedClientLink>
    </div>
  )
}

export default EmptyCartMessage
